import * as React from 'react';

import {
  Colors,
  Lang,
  Breakpoint,

  useDimensions,

  Text,
  TextBlock,
} from '@bluecurrent/web-component-lib';

import Setup from '../../../config/Setup.config';

import IconHandler from '../IconHandler';

export default function Item(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  return (
    <div
      style={{
        flex: '1 1 auto',
        width: '100%',
        border: `solid 2px ${Colors.MEDIUM_WHITE}`,
        borderRadius: 10,
        backgroundColor: Colors.LIGHT_GREY,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: 5,
        }}
      >
        <div
          style={{
            paddingLeft: 10,
            paddingTop: 10,
            position: 'relative',
            zIndex: 0,
          }}
        >
          <IconHandler
            data={props.data.icon}
            height={80}
            width={80}
            color={Colors.GREY}
          />
        </div>
        <div
          style={{
            height: 40,
            width: 40,
            backgroundColor: Colors.LIGHT_WHITE,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            border: `solid 2px ${Colors.MEDIUM_WHITE}`,
            borderRadius: 7.5,
          }}
        >
          <Text
            color={Colors.GREY}
            fontSize="1.5"
            fontWeight={500}
            textAlign="center"
          >
            {props.index + 1}
          </Text>
        </div>
      </div>
      <div
        style={{
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 10,
        }}
      >
        <TextBlock
          title={{
            content: props.data.text_block.title !== undefined && (
              props.data.text_block.title[lang]
            ),
            portableText: props.data.text_block.title !== undefined,
            fontSize: '1.5em',
            heading: 3,
          }}
          text={{
            content: (!props.loading && props.data.text_block.text !== undefined) && (
              props.data.text_block.text[lang]
            ),
            portableText: !props.loading && props.data.text_block.text !== undefined,
            color: Colors.GREY,
          }}
          align={
            size.width < Breakpoint.sm
              ? (props.data.text_block.align ?? 'left')
              : (
                props.data.icon !== undefined
                && props.data.text_block.title === undefined
              )
                ? 'center'
                : 'left'
          }
        />
      </div>
    </div>
  );
}
